import { useState } from "react";
import { Col, Divider, Input, Row, Switch } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import BotonSubmit from "../../../../../../components/Boton/BotonSubmit";
import LabelTextarea from "../../../../../../components/input/LabelTextarea";
import { DatosSucursal } from "../../DatosSucursal";
import BotonDivLeft2 from "../../../../../../components/Boton/BotonDivLeft2";
import LabelSelect from "../../../../../../components/select/LabelSelect";
import LabelNumber from "../../../../../../components/input/LabelNumber";
import LabelText from "../../../../../../components/input/LabelText";
import { formatKmCalculados } from "../../../../../../utils/formatKmCalculados";
import {
  CLIENTES_IDS,
  cuentaEspecialGNPOpciones,
  cuentaEspecialGSPOpciones,
} from "../../../../../../constants/cons";
import { AsignacionApi } from "../../../asignacionApi/AsignacionApi";
import { useForma } from "./useForma";
import { InicioAsignacion } from "./_InicioAsignacion";

const localOpciones = [
  { texto: "local", valor: "local" },
  { texto: "carretero", valor: "carretero" },
];

const tiempoLlegadaOpciones = [
  { texto: "15 minutos", valor: 15 },
  { texto: "30 minutos", valor: 30 },
  { texto: "45 minutos", valor: 45 },
  { texto: "1 hora", valor: 60 },
  { texto: "1 hora 15 minutos", valor: 75 },
  { texto: "1 hora 30 minutos", valor: 90 },
  { texto: "1 hora 45 minutos", valor: 105 },
  { texto: "2 horas", valor: 120 },
  { texto: "2 horas 15 minutos", valor: 135 },
  { texto: "2 horas 30 minutos", valor: 150 },
  { texto: "2 horas 45 minutos", valor: 165 },
  { texto: "3 horas", valor: 180 },
  { texto: "3 horas 15 minutos", valor: 195 },
  { texto: "3 horas 30 minutos", valor: 210 },
  { texto: "3 horas 45 minutos", valor: 225 },
  { texto: "4 horas", valor: 240 },
  { texto: "4 horas 15 minutos", valor: 255 },
  { texto: "4 horas 30 minutos", valor: 270 },
  { texto: "4 horas 45 minutos", valor: 285 },
  { texto: "5 horas", valor: 300 },
  { texto: "Otro tiempo", valor: "otro" },
];

const otroTiempoMinutosOpciones = [
  { texto: "0 minutos", valor: 0 },
  { texto: "15 minutos", valor: 15 },
  { texto: "30 minutos", valor: 30 },
  { texto: "45 minutos", valor: 45 },
];

export const Forma = ({ handleVerMapa, handleHistorial, handleDesgloseCostos }) => {
  const [otroTiempoLlegada, setOtroTiempoLlegada] = useState(false);
  const [otroTiempoHoras, setOtroTiempoHoras] = useState(0);
  const [otroTiempoMinutos, setOtroTiempoMinutos] = useState(0);
  
  const {
    datos,
    estatusFinalID,
    campaniaID,
    handleChange,
    handleChangeSelect,
    handleCuentaEspecial,
    handleSwitch,
    handleClick,
    kmCalculados,
    err,
    loading,
    cuentaEspecialGS,
  } = useForma();

  const kmLabel = formatKmCalculados(kmCalculados);

  function handleTiempoLlegadaSelect(val) {
    if (val === "otro") {
      setOtroTiempoLlegada(true);
      setOtroTiempoHoras(0);
      setOtroTiempoMinutos(0);
      handleChange({ target: { name: "tiempoLlegada", value: 0 } });
    } else {
      setOtroTiempoLlegada(false);
      handleChange({ target: { name: "tiempoLlegada", value: val } });
    }
  }

  function handleOtroTiempoHoras({ target }) {
    if (target.value === "") {
      setOtroTiempoHoras(0);
      handleChange({ target: { name: "tiempoLlegada", value: otroTiempoMinutos } });
    } else {
      const horas = parseInt(target.value);
      setOtroTiempoHoras(horas);
      handleChange({
        target: { name: "tiempoLlegada", value: horas * 60 + otroTiempoMinutos },
      });
    }
  }

  function handleOtroTiempoMinutos(val) {
    setOtroTiempoMinutos(val);
    handleChange({
      target: { name: "tiempoLlegada", value: otroTiempoHoras * 60 + val },
    });
  }

  ///////////////////
  return (
    <div style={{ width: 350 }}>
      <div style={{ marginBottom: 15 }}>
        <Row style={{ marginBottom: 20 }} gutter={[15, 15]}>
          <Col span={12}>
            <BotonDivLeft2
              onClick={handleHistorial}
              tituloBoton="Historial de Asignación"
            />
          </Col>
          <Col span={12}>
            <BotonDivLeft2 onClick={handleVerMapa} tituloBoton="Asignar Proveedor (mapa)" />
          </Col>
          <Col span={12}>
            <BotonDivLeft2
              onClick={handleDesgloseCostos}
              tituloBoton="Desglose de costos"
            />
          </Col>
          <Col span={12}>
            <div style={{ width: "100%" }}>
              <AsignacionApi />
            </div>
          </Col>
        </Row>
      </div>

      <Divider />
      <DatosSucursal />

      <InicioAsignacion />

      <Row gutter={[10, 10]} style={{ marginBottom: 15 }} justify="center">
        <Col>
          <Switch
            checkedChildren="Si pago directo"
            unCheckedChildren="No pago directo"
            onChange={(val) => handleSwitch(val, "esPagoDirecto")}
          />
        </Col>
      </Row>

      <Row gutter={[10, 10]} style={{ marginBottom: 15 }}>
        {campaniaID === 2 && (
          <Col span={24}>
            <LabelSelect
              label="Cuenta Especial GNP"
              name="cuentaEspecialGNP"
              value={datos.cuentaEspecialGNP}
              onChange={(val)=>handleCuentaEspecial(val, "cuentaEspecialGNP")}
              opciones={cuentaEspecialGNPOpciones}
            />
          </Col>
        )}
        {(campaniaID === CLIENTES_IDS.GS_PROD ||
          campaniaID === CLIENTES_IDS.GS_DEV) && (
          <Col span={24}>
            <LabelSelect
              label="Cuenta Especial GS"
              name="cuentaEspecialGS"
              value={datos.cuentaEspecialGS}
              onChange={(val)=>handleCuentaEspecial(val, "cuentaEspecialGS")}
              opciones={cuentaEspecialGSPOpciones}
            />
          </Col>
        )}
      </Row>

      <Row gutter={[10, 10]} style={{ marginBottom: 15 }}>
        <Col span={12}>
          {" "}
          <LabelSelect
            label={<>Local / Carretero <span style={{color: 'red'}}>*</span></>}
            name="localCarretero"
            onChange={handleChangeSelect}
            opciones={localOpciones}
          />
        </Col>

        <Col span={12}>
          <LabelNumber
            label={"" + kmLabel}
            name="KM"
            onChange={handleChange}
            value={datos.KM}
          />
        </Col>
        <Col span={24}>
          <LabelSelect
            label={<>Tiempo llegada (mins) <span style={{color: 'red'}}>*</span></>}
            name="tiempoLlegada"
            value={otroTiempoLlegada ? "otro" : datos.tiempoLlegada}
            onChange={handleTiempoLlegadaSelect}
            opciones={tiempoLlegadaOpciones}
          />
          {otroTiempoLlegada && (
            <Row gutter={[10, 10]} style={{ marginTop: 10 }}>
              <Col span={12}>
                <div className="inputLabel">
                  Horas <span style={{ color: "red" }}>*</span>
                </div>
                <Input
                  type="number"
                  name="tiempoLlegadaHoras"
                  value={otroTiempoHoras}
                  onChange={handleOtroTiempoHoras}
                  onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 2);
                  }}
                />
              </Col>
              <Col span={12}>
                <LabelSelect
                  label="Minutos"
                  name="tiempoLlegadaMinutos"
                  value={otroTiempoMinutos}
                  onChange={handleOtroTiempoMinutos}
                  opciones={otroTiempoMinutosOpciones}
                />
              </Col>
            </Row>
          )}
        </Col>
      </Row>

      <Divider />

      <Row gutter={[10, 10]} style={{ marginBottom: 15 }}>
        <Col span={24}>
          <LabelNumber
            name="costo"
            label={<>Costo <span style={{color: 'red'}}>*</span></>}
            onChange={handleChange}
            value={datos.costo}
            hint="Lo que va a facturar proveedor para que pague Escotel"
          />
        </Col>
        <Col span={12}>
          <LabelNumber
            name="costoClienteCorporativo"
            label="Costo Corporativo"
            onChange={handleChange}
            value={datos.costoClienteCorporativo}
            hint="Es el costo que paga Escotel, pero se lo cobra al cliente corporativo después"
          />
        </Col>
        <Col span={12}>
          <LabelText
            name="quienAutoriza"
            label={datos.costoClienteCorporativo ? <>Quien autoriza <span style={{color: 'red'}}>*</span></> : "Quien autoriza"}
            onChange={handleChange}
            value={datos.quienAutoriza}
            disabled={!datos.costoClienteCorporativo}
            hint="Es el personal del Cliente Corporativo que autoriza dicho pago"
          />
        </Col>
        <Col span={24}>
          <LabelTextarea
            name="motivoExcedente"
            value={datos.motivoExcedente}
            label="Comentario excedente"
            onChange={handleChange}
          />
        </Col>

        <Col span={12}>
          <LabelNumber
            name="costoUsuarioFinal"
            label="Costo Usuario Final"
            onChange={handleChange}
            value={datos.costoUsuarioFinal}
            hint="Lo paga el usuario final en el momento, costos no incluidos en el servicio"
          />
        </Col>
        <Col span={12}>
          <LabelNumber
            name="costoTotalServicio"
            label="Total de Servicio"
            value={datos.costoTotalServicio}
            disabled
            hint="Es el total de lo que recibe el proveedor por el servicio: Costo + Costo Usuario Final"
          />
        </Col>
      </Row>


      <Row gutter={[10, 10]} style={{ marginBottom: 20 }}>
        <Col span={24}>
          <LabelTextarea
            name="comentarios"
            value={datos.comentarios}
            label="Comentario de asignación"
            onChange={handleChange}
          />
        </Col>
      </Row>

      <div style={{ marginBottom: 10, marginTop: 10 }}>
        <Row gutter={10} justify="center">
          <Col>
            <BotonSubmit
              disabled={estatusFinalID !== 1}
              onClick={() => handleClick(0)}
              tituloBoton="No asignar"
              icon={<CloseCircleOutlined />}
              loading={loading}
            />
          </Col>
          <Col>
            <BotonSubmit
              disabled={estatusFinalID !== 1}
              onClick={() => handleClick(1)}
              tituloBoton="Asignar"
              icon={<CheckCircleOutlined />}
              loading={loading}
            />
          </Col>
        </Row>
        {err && (
          <Row justify="center" style={{ marginTop: 8 }}>
            <Col>
              <div style={{ color: "#ca2228" }}>{err}</div>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};
